<ng-template #tooltipContent>
  @let skillData = display();

  <div class="flex flex-row gap-4 p-2">
    <div class="relative w-[64px] h-[64px] min-w-[64px] min-h-[64px] shrink-0">
      <app-icon-item-preview [sprite]="skillData.sprite" spritesheet="skill" />
    </div>

    <div>
      <div class="type-entity-name mb-1 text-{{ skillData.rarity }}">
        {{ skillData.name }}
        @if (isSpecial()) {
          <span class="badge badge-sm badge-data ml-1">Burst</span>
        }
      </div>

      <app-detail-skill-preview
        [skill]="skillData"
        [combatant]="displayCombatant()"
        [characterWeaponTypes]="displayCharacterWeaponTypes()"
      />

      <ng-container [ngTemplateOutlet]="footer() ?? null" />
    </div>
  </div>
</ng-template>
